import React from 'react';

export default function(props) {
    return (
        <div>
            <button 
                type="button"
                className="tickets-count-button"
                disabled={props.value === "0" || !props.value}
                onClick={() => props.onChange(props.value - 1)}>–</button>
            <input
                className="tickets-count-input"
                type="number"
                placeholder="0"
                id={props.id}
                value={props.value}
                min="0"
                disabled />
            <button
                type="button"
                className="tickets-count-button"
                disabled={!props.increaseAllowed}
                onClick={() => props.onChange(props.value + 1)}>+</button>
        </div>
    );
}
